import { lazy, ReactElement, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import appPage from '../../../hoc/appPage';
import dataModel from '../../../models/data';
import appConfig from '../../../configs/app.json';
import { usePartnerConfig } from '../../../contexts/partnerConfig';

const MobileContent = lazy(() => import('./MobileContent'));
const DesktopContent = lazy(() => import('./DesktopContent'));

function AuthenticatedPage(): ReactElement {
  const {
    canChangeLanguageOnMobile,
    brandingInfo: { clientId, isSsoClient }
  } = dataModel;

  const { config } = usePartnerConfig();
  const isDesktop = useMediaQuery({
    minWidth: appConfig.desktopMinWidth,
    minHeight: appConfig.desktopMinHeight
  });

  const showLogoutButton = !isSsoClient;

  return useMemo(
    () =>
      isDesktop ? (
        <DesktopContent
          enableIntercom={Boolean(config?.enableIntercom)}
          clientId={clientId}
          showLogoutButton={showLogoutButton}
        />
      ) : (
        <MobileContent canChangeLanguageOnMobile={canChangeLanguageOnMobile} />
      ),
    [isDesktop]
  );
}

export default appPage(AuthenticatedPage);
